import React from 'react';
import './machine&deep-learning.css';
import '../inner_pages.css';
import M_main from './m_main'
import M_learning from './m_learning'
import M_wywl from './m_wywl'
import M_wywl2 from './m_wywl2'
import M_meet from './m_meet'
import M_attend from './m_attend'
import Header from '../../../../components/Header_inner/Header';
import Packages from '../../../../components/Packages/Packages';

const MachineDeepLearning = () => {
    return (
        <div className="machine-deep-learning__wrap">
            <Header />
            <M_main />
            <M_learning />
            <M_wywl />
            <M_wywl2 />
            <M_meet />
            <M_attend />
            <Packages />
        </div>
    );
};

export default MachineDeepLearning;